import { Context } from '@nuxt/types';

export default function(ctx: Context) {
    if (ctx.route.fullPath !== '/' && ctx.route.name !== 'submit-rebate' && (!ctx.store.state.path.path || !ctx.store.state.source.source)) {
        (/true/i).test(ctx.env.enableRouteGuards) && ctx.redirect({ path: '/' });
    }
}
